

export default function Gameover() {

    function restart() {
        console.log('restart triggered')
        window.location.reload(true);
    }

    function getRandomQuote() {
        const quotes = [
          "Eternally ensnared in the crimson threads of the abyss. - Edgar Allan Poe",
          "Lost in the red echoes, a prisoner of the infinite descent. - H.P. Lovecraft",
          "Endless steps, where time stands still, and escape is but a distant dream. - Nathaniel Hawthorne",
          "In the shadowy depths, the steps of eternity echo for those who cannot break free. - Mary Shelley",
          "A descent into the red unknown, where the clock ticks eternally. - Edgar Lee Masters",
          "Beneath the endless staircase, the soul lingers, forever entwined in the surreal. - Emily Dickinson",
          "Bound to the staircase of infinity, where the footsteps of escape fade into the abyss. - Ambrose Bierce",
          "In the crimson labyrinth, where echoes of despair outlast the passage of time. - Charles Dickens"
        ];
      
        const randomIndex = Math.floor(Math.random() * quotes.length);
        return quotes[randomIndex];
      }

    const randomQuote = getRandomQuote()
    console.log('randomQuote', randomQuote)

    return <>
        <div className='gameover-screen'>
            <div className='gameover-message'><q>{randomQuote}</q></div>
            <div className="restart" onClick={restart}>try again</div>
            <div className='gameover-disclaimer'>(press ESC key to show cursor)</div>
        </div>
    </>
}